document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.tags-wrapper');
  if (!wrappers.length) return;

  const checkOverflow = (wrapper) => {
    const tags = wrapper.querySelector('.tags');
    const toggle = wrapper.querySelector('.tags-toggle');
    if (!tags || !toggle) return;

    const isOverflowing = tags.scrollHeight > tags.clientHeight;
    const isExpanded = tags.classList.contains('-expanded');

    toggle.classList.toggle('-visible', isOverflowing || isExpanded);
  };

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const wrapper = e.currentTarget.closest('.tags-wrapper');
    const tags = wrapper.querySelector('.tags');
    const toggle = e.currentTarget;
    const isExpanded = tags.classList.contains('-expanded');

    if (!isExpanded) {
      // Opening: float first, then expand
      tags.classList.add('-floating', '-expanded');
      toggle.classList.add('-active');
      toggle.setAttribute('aria-expanded', 'true');
    } else {
      // Closing: collapse first, remove float after transition
      tags.classList.remove('-expanded');
      toggle.classList.remove('-active');
      toggle.setAttribute('aria-expanded', 'false');

      tags.addEventListener('transitionend', () => {
        tags.classList.remove('-floating');
      }, { once: true });
    }
  };

  wrappers.forEach((wrapper) => {
    const toggle = wrapper.querySelector('.tags-toggle');
    if (toggle) {
      toggle.addEventListener('click', handleToggle);
    }
    checkOverflow(wrapper);
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => wrappers.forEach(checkOverflow), 150);
  });
});
